import { Row as RACRow, RowProps } from "react-aria-components";
import { rowStyles } from "./tables.css";

const Row = <T extends object>({ children, ...props }: RowProps<T>) => (
  <RACRow className={rowStyles} {...props}>
    {children}
  </RACRow>
);

export default Row;
